/*
  Script custom.

  Caricato dopo layout.theme.js (vedi snippets/script-tags.liquid).
  layout.theme.js è un bundle compilato i cui sorgenti non sono nel repo:
  i comportamenti nuovi vanno qui, non nel bundle. jQuery è già globale.
*/

/* ==========================================================================
   Mega menu desktop: apertura al click
   ========================================================================== */

/*
  Nel tema originale il dropdown si apre in hover, via CSS. custom.css disattiva
  quella regola e mostra il dropdown della voce con classe is-open, gestita qui.
  Il menu mobile (drawer) non è coinvolto: .site-nav__main esiste solo da 1021px.
*/
(function ($) {
  var $nav = $('.site-nav__main');
  if (!$nav.length) return;

  var OPEN_CLASS = 'is-open';
  var PARENT_LINK = '.site-nav__item--level-1.site-nav--has-dropdown > a';
  var desktop = window.matchMedia('(min-width: 1021px)');

  // Il bundle mostra e nasconde il backdrop in hover sulle voci di primo livello.
  $nav.off('mouseenter mouseleave', '[data-meganav-level="1"]');

  // Su desktop le voci con dropdown aprono il menu invece di portare a una pagina: per la
  // tastiera e gli screen reader sono pulsanti. Quelle senza href non sarebbero nemmeno
  // raggiungibili con Tab senza tabindex.
  $nav.find(PARENT_LINK).attr('role', 'button');
  $nav.find(PARENT_LINK).not('[href]').attr('tabindex', 0);

  function closeMenu() {
    var $open = $nav.children('.' + OPEN_CLASS);
    if (!$open.length) return;

    $open.removeClass(OPEN_CLASS).children('a').attr('aria-expanded', 'false');
    $('#backdrop').removeClass('is-visible');
    $('.site-header').removeClass('is-menu-open');
  }

  function openMenu($item) {
    closeMenu();
    $item.addClass(OPEN_CLASS).children('a').attr('aria-expanded', 'true');
    $('#backdrop').addClass('is-visible');
    // L'header torna bianco pieno finché il dropdown è aperto (custom.css).
    $('.site-header').addClass('is-menu-open');
  }

  // Click sulla voce: apre, oppure chiude se è già aperta. Il link della voce non viene seguito.
  $nav.on('click', PARENT_LINK, function (event) {
    var $item = $(this).parent();
    if (!$item.children('[data-meganav-dropdown]').length) return;

    event.preventDefault();

    if ($item.hasClass(OPEN_CLASS)) {
      closeMenu();
    } else {
      openMenu($item);
    }
  });

  $nav.on('keydown', PARENT_LINK, function (event) {
    if ($(this).is('[href]')) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).trigger('click');
    }
  });

  // Click fuori dalla voce aperta (pagina, backdrop, resto dell'header): chiude.
  $(document).on('click', function (event) {
    if (!$(event.target).closest('.site-nav__main > .' + OPEN_CLASS).length) {
      closeMenu();
    }
  });

  $(document).on('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var $link = $nav.children('.' + OPEN_CLASS).children('a');
    if (!$link.length) return;

    closeMenu();
    $link.trigger('focus');
  });

  // Con la tastiera, quando il focus esce dalla voce aperta (Tab oltre l'ultimo link
  // del dropdown, o Maiusc+Tab prima della voce) il menu si chiude.
  $nav.on('focusout', '> .' + OPEN_CLASS, function (event) {
    if (event.relatedTarget && !this.contains(event.relatedTarget)) closeMenu();
  });

  // Sotto i 1021px il menu desktop sparisce: non deve restare il backdrop.
  $(window).on('resize', function () {
    if (!desktop.matches) closeMenu();
  });
})(jQuery);

/* ==========================================================================
   Accessibilità da tastiera
   ========================================================================== */

/*
  Barra annunci: il carosello (slick, nel bundle) toglie dalla tastiera i link di
  tutte le slide, compresa quella visibile. A ogni cambio la slide in arrivo
  torna raggiungibile con Tab: si usa beforeChange perché la transizione dura
  un secondo, e aspettando afterChange per quel tempo la slide visibile resterebbe
  esclusa. Il bundle inizializza slick al DOM ready, prima dei gestori registrati
  qui: l'evento init è già passato, quindi si sistema anche subito.
*/
(function ($) {
  var $slideshow = $('.strip-slideshow');
  if (!$slideshow.length) return;

  function updateTabindex($current) {
    $slideshow.find('.slick-slide a').attr('tabindex', -1);
    $current.find('a').attr('tabindex', 0);
  }

  $slideshow.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    updateTabindex($slideshow.find('.slick-slide[data-slick-index="' + nextSlide + '"]'));
  });

  $(function () {
    updateTabindex($slideshow.find('.slick-current'));
  });
})(jQuery);

/*
  Elementi focusabili e visibili dentro un contenitore: servono per tenere il
  Tab dentro i pannelli aperti.
*/
function getFocusable(container) {
  var selector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  return Array.prototype.filter.call(container.querySelectorAll(selector), function (element) {
    return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  });
}

/*
  Sposta il focus su un elemento che sta comparendo con un'animazione: finché è
  ancora visibility: hidden il focus non viene accettato, quindi si riprova a
  ogni frame per al massimo mezzo secondo.
*/
function focusWhenVisible(element) {
  var start = Date.now();

  (function attempt() {
    element.focus();
    if (document.activeElement !== element && Date.now() - start < 500) {
      requestAnimationFrame(attempt);
    }
  })();
}

/*
  Riporta il focus sul pulsante che ha aperto un pannello, se nel frattempo è
  finito nel pannello che si sta chiudendo o sul body. Si aspetta un frame
  perché il bundle, chiudendo, toglie il focus (blur) dopo che la classe è cambiata.
*/
function restoreFocus(opener, container) {
  if (!opener) return;

  requestAnimationFrame(function () {
    var active = document.activeElement;
    if (!active || active === document.body || container.contains(active)) {
      opener.focus();
    }
  });
}

/*
  Tab e Maiusc+Tab restano dentro il contenitore: dall'ultimo elemento si torna
  al primo e viceversa.
*/
function trapTab(event, container) {
  if (event.key !== 'Tab') return;

  var focusable = getFocusable(container);
  if (!focusable.length) return;

  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  if (event.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) {
    event.preventDefault();
    first.focus();
  }
}

/*
  Carrello laterale, gestito dal bundle (timber.Drawers). Da tastiera:
  - all'apertura il focus va sul pulsante di chiusura, dentro il pannello;
  - finché è aperto, Tab resta nel pannello;
  - Esc lo chiude, come indica l'etichetta "Chiudi (Esc)";
  - alla chiusura il focus torna sul pulsante Carrello.
  Lo stato è la classe js-drawer-open-right sul body, messa dal bundle: la si
  osserva invece di agganciarsi ai suoi eventi.
*/
(function ($) {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var OPEN_CLASS = 'js-drawer-open-right';
  var wasOpen = document.body.classList.contains(OPEN_CLASS);
  var opener = null;

  // Ultimo elemento con il focus fuori dal pannello: all'apertura il bundle
  // sposta il focus sul pannello prima che lo script se ne accorga, quindi
  // l'elemento di partenza va registrato prima.
  var lastOutside = null;
  document.addEventListener('focusin', function (event) {
    if (!drawer.contains(event.target)) lastOutside = event.target;
  });

  new MutationObserver(function () {
    var isOpen = document.body.classList.contains(OPEN_CLASS);
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;

    if (isOpen) {
      opener = lastOutside;
      var close = drawer.querySelector('.js-drawer-close');
      if (close) focusWhenVisible(close);
    } else {
      restoreFocus(opener, drawer);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  $(document).on('keydown', function (event) {
    if (!document.body.classList.contains(OPEN_CLASS)) return;

    if (event.key === 'Escape') {
      $(drawer).find('.js-drawer-close').trigger('click');
      return;
    }

    trapTab(event, drawer);
  });
})(jQuery);

/*
  Pannello di ricerca nell'header (#top-search-wrapper), aperto e chiuso dal
  bundle con la classe expanded. Da tastiera:
  - all'apertura il focus va sul pannello, non nel campo di testo: il Tab
    successivo porta nel campo. Il campo non riceve il focus da solo perché
    Doofinder (app di ricerca) si apre appena un input[name="q"] lo riceve:
    "Cerca" deve mostrare la barra del tema, e Doofinder deve partire solo
    quando il visitatore entra nel campo, come prima;
  - Esc lo chiude;
  - alla chiusura il focus torna sul link Cerca.
  Con Doofinder aperto sopra il pannello (vedi sotto) Esc lo gestisce Doofinder.
  aria-expanded sul link Cerca dice agli screen reader se il pannello è aperto.
*/
(function ($) {
  var panel = document.getElementById('top-search-wrapper');
  var $toggle = $('.js-toggle-search-modal');
  if (!panel || !$toggle.length) return;

  $toggle.attr({ 'aria-controls': 'top-search-wrapper', 'aria-expanded': 'false' });
  // Focalizzabile da script ma non con Tab.
  panel.setAttribute('tabindex', '-1');

  new MutationObserver(function () {
    var isOpen = panel.classList.contains('expanded');
    if (String(isOpen) === $toggle.attr('aria-expanded')) return;

    $toggle.attr('aria-expanded', String(isOpen));

    if (isOpen) {
      focusWhenVisible(panel);
    } else {
      restoreFocus($toggle.filter(':visible').get(0), panel);
    }
  }).observe(panel, { attributes: true, attributeFilter: ['class'] });

  $(document).on('keydown', function (event) {
    if (event.key === 'Escape' && panel.classList.contains('expanded') && !isDoofinderOpen()) {
      panel.classList.remove('expanded');
    }
  });

  /*
    Doofinder si apre a tutto schermo sopra il pannello quando il visitatore entra
    nel campo. Prima, chiudendo Doofinder, sotto restava aperto il pannello del
    tema. Ora, quando Doofinder si chiude, si chiude anche il pannello e il focus
    torna su "Cerca".
    Doofinder, mentre è aperto, aggiunge la classe dfd-fixed-layout a <html>.
    Chiudendosi rimette il focus nel campo del pannello: per un secondo, se il
    focus rientra nel pannello ormai chiuso, viene riportato su "Cerca".
  */
  var DOOFINDER_OPEN_CLASS = 'dfd-fixed-layout';
  var doofinderWasOpen = isDoofinderOpen();
  var redirectUntil = 0;

  function isDoofinderOpen() {
    return document.documentElement.classList.contains(DOOFINDER_OPEN_CLASS);
  }

  new MutationObserver(function () {
    var doofinderOpen = isDoofinderOpen();
    if (doofinderOpen === doofinderWasOpen) return;
    doofinderWasOpen = doofinderOpen;

    if (!doofinderOpen && panel.classList.contains('expanded')) {
      redirectUntil = Date.now() + 1000;
      panel.classList.remove('expanded');
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  panel.addEventListener('focusin', function () {
    if (Date.now() < redirectUntil && !panel.classList.contains('expanded')) {
      var toggle = $toggle.filter(':visible').get(0);
      if (toggle) toggle.focus();
    }
  });
})(jQuery);
